export const equalArrays = (a: string[], b: string[]) => {
  return a.length === b.length && a.every((value) => b.indexOf(value) >= 0);
};
